import { stepUpAwareFetch } from '~/lib/api/stepUpFetch';

export const sandboxOptions = {
  fetch: (request: Request) => {
    request.headers.set('Live-Mode', 'No');
    return stepUpAwareFetch(request);
  },
};
